import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		status: '',
		token: localStorage.getItem('token') || '',
		user: {},
		plan: null,
	},
	mutations: {
		auth_request(state) {
			state.status = 'loading'
		},
		auth_success(state, token, user) {
			console.log(Vue.axios.defaults.headers);
			Vue.axios.defaults.headers = {
				Authorization: 'Bearer ' + 
				token,
				"Content-Type": "Content-Type:application/json",
			} ;
			state.status = 'success'
			state.token = token
			state.user = user
		},
		auth_error(state) {
			state.status = 'error'
		},
		logout(state) {
			state.status = ''
			state.token = ''
			Vue.axios.defaults.headers = {
				Authorization: 'Bearer ' + 
				'',
				"Content-Type": "Content-Type:application/json",
			} ;
		},
		setPlan(state, plan) {
			state.plan = plan;
		},
	},
	actions: {
		login({ commit }, user) {
			window.axios = require('axios');
			return new Promise((resolve, reject) => {
				commit('auth_request')
				axios({ url: '/user/login', data: user, method: 'POST' })
					.then(resp => {
						const token = resp.data.token
						const user = resp.data.user
						
						console.log(user);
						console.log(token);
						localStorage.setItem('token', token)
						
						console.log(localStorage.token);
						//Vue.axios.defaults.headers.common['Authorization'] = token;
						commit('auth_success', token, user);
						resolve(resp);
					})
					.catch(err => {
						commit('auth_error')
						localStorage.removeItem('token')
						reject(err)
					})
			})
		},
		logout({ commit }) {
			return new Promise((resolve , reject) => {
				axios({ url: '/user/logout', method: 'POST' })
				.then(resp => {		
					commit('logout');
					console.log(resp);
					localStorage.removeItem('token');
					resolve();
				})
				.catch(err => {
					reject(err)
				})
			
			})
		},
		getPlan({ commit }) {
			return new Promise((resolve) => {
				axios({ url: '/subscription/status', method: 'GET' })
				.then(response => {	
					console.log("=-----Response-----=");
					if(response.data){
						console.log("=-----Other-----=");
						commit('setPlan', response.data.plan_id);
					}else {
						console.log("=-----Free-----=");
						commit('setPlan', 'Free');
					}
					
					console.log(response);
					//commit('setPlan', resp.data.plan);
					resolve();
				})
				.catch(error => {
					if (error.response) {
						// Request made and server responded
						console.log(error.response.data);
						console.log(error.response.status);
						console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					resolve();
				})
			
			})
		}
	},
	getters: {
		isLoggedIn: state => !!state.token,
		authStatus: state => state.status,
		plan: state => state.plan,
	}
})